module.exports = __webpack_public_path__ + "img/4.66b54e45.jpg";